import React, { useEffect } from "react";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import RejectedSheet from "./RejectedSheet";
import ApprovedSheet from "./ApprovedSheet";
import PendingSheet from "./PendingSheet";
import AllSheet from "./AllSheet";
import Pagenotfound from "../../components/common/Pagenotfound";
import { useDispatch, useSelector } from "react-redux";
import { setOTCounts } from "../../selectSlice";
import OTSheetDetail from "./OTSheetDetail";


function OTSheetModule() {
  const location = useLocation();
  const isActiveTab = (path) => location.pathname.includes(path);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { role: login_user_role } = login_user;
  const dispatch = useDispatch();
  const counts = useSelector((state) => state.selectOptions.otCounts);
    const hideTabs = location.pathname.includes("OTSheetDetail");

  useEffect(() => {
    const storedCounts = {
      total_count: Number(localStorage.getItem("total_count")) || 0,
      total_pending: Number(localStorage.getItem("total_pending")) || 0,
      total_approved: Number(localStorage.getItem("total_approved")) || 0,
      total_rejected: Number(localStorage.getItem("total_rejected")) || 0,
    };
    if (JSON.stringify(storedCounts) !== JSON.stringify(counts)) {
      dispatch(setOTCounts(storedCounts));
    }
  }, []);



  return (
    <div className="bg-white p-3 detailpage">
       {!location.pathname.includes("OTSheetDetail") && (
      <ul className="nav nav-tabs" role="tablist">
        <li className="nav-item pe-3" role="presentation">
          <Link
            to="Pending-Sheet"
            className={`nav-link ${
              isActiveTab("Pending-Sheet") ? "active" : ""
            }`}
            role="tab"
          >
            Pending ({counts.total_pending})
          </Link>
        </li>
        <li className="nav-item pe-3" role="presentation">
          <Link
            to="Approved-Sheet"
            className={`nav-link ${
              isActiveTab("Approved-Sheet") ? "active" : ""
            }`}
            role="tab"
          >
            Approved ({counts.total_approved})
          </Link>
        </li>
        <li className="nav-item pe-3" role="presentation">
          <Link
            to="Rejected-Sheet"
            className={`nav-link ${
              isActiveTab("Rejected-Sheet") ? "active" : ""
            }`}
            role="tab"
          >
            Rejected ({counts.total_rejected})
          </Link>
        </li>
        <li className="nav-item pe-3" role="presentation">
          <Link
            to="All-Sheet"
            className={`nav-link ${isActiveTab("All-Sheet") ? "active" : ""}`}
            role="tab"
          >
            All ({counts.total_count})
          </Link>
        </li>
      </ul>
 )}
      {/* Tab Content */}
      <div className="tab-content" id="myTabContent">
        <Routes>
          <Route index element={<Navigate to="Pending-Sheet" replace />} />
          <Route path="Pending-Sheet" element={<PendingSheet />} />
          <Route path="Approved-Sheet" element={<ApprovedSheet />} />
          <Route path="Rejected-Sheet" element={<RejectedSheet />} />
          <Route path="All-Sheet" element={<AllSheet />} />
          <Route path="OTSheetDetail" element={<OTSheetDetail />} />
          <Route path="*" element={<Pagenotfound />} />
        </Routes>
      </div>
    </div>
  );
}

export default OTSheetModule;
